import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { OwnRestrictedListActionTypes } from 'store/actions/own-restricted-list.actions';
var initialState = {
    loading: [],
    ownRestrictedList: null,
    ownRestrictedLists: null,
    addRestricted: null,
    editRestricted: null,
    restrictedNames: null,
    addRestrictedName: null,
    editRestrictedName: null,
    err: null,
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST), ownRestrictedList: action.payload });
        }
        case OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST), err: action.payload });
        }
        case OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS), ownRestrictedLists: action.payload });
        }
        case OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS), err: action.payload });
        }
        case OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST), addRestricted: action.payload });
        }
        case OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST), err: action.payload });
        }
        case OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST), editRestricted: action.payload });
        }
        case OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST), err: action.payload });
        }
        case OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES), restrictedNames: action.payload });
        }
        case OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES), err: action.payload });
        }
        case OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME), addRestrictedName: action.payload });
        }
        case OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME), err: action.payload });
        }
        case OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME), editRestrictedName: action.payload });
        }
        case OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME_FAILURE: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME), err: action.payload });
        }
        case OwnRestrictedListActionTypes.RESET_RESTRICTED_STATE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}
var ownRestrictedList = function (state) { return state.ownRestrictedList; };
var ɵ0 = ownRestrictedList;
var ɵ1 = function (state) { return state.err; }, ɵ2 = function (state) { return state.loading; }, ɵ3 = function (state) { return state.ownRestrictedList; }, ɵ4 = function (state) { return state.ownRestrictedLists; }, ɵ5 = function (state) { return state.addRestricted; }, ɵ6 = function (state) { return state.editRestricted; }, ɵ7 = function (state) { return state.restrictedNames; }, ɵ8 = function (state) { return state.addRestrictedName; }, ɵ9 = function (state) { return state.editRestrictedName; };
export var Selectors = {
    getErrors: createSelector(ownRestrictedList, ɵ1),
    getLoading: createSelector(ownRestrictedList, ɵ2),
    getOwnRestrictedList: createSelector(ownRestrictedList, ɵ3),
    getOwnRestrictedLists: createSelector(ownRestrictedList, ɵ4),
    addRestricted: createSelector(ownRestrictedList, ɵ5),
    editRestricted: createSelector(ownRestrictedList, ɵ6),
    getRestrictedNames: createSelector(ownRestrictedList, ɵ7),
    addRestrictedName: createSelector(ownRestrictedList, ɵ8),
    editRestrictedName: createSelector(ownRestrictedList, ɵ9)
};
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9 };
